import { rootRouteId, useRouteContext } from "@tanstack/react-router";

/**
 * The root route's auth gate, or `undefined` while it is being re-resolved.
 *
 * The route context is typed as if `authGateState` were always present, and
 * once a load has settled it is. But every navigation re-runs the root
 * `beforeLoad`, and the router resets the root match's context to its parent's
 * before awaiting it. When that takes longer than `pendingMs` — the network
 * bootstrap right after pairing on a slow client — the router renders the
 * in-flight matches to show the pending UI, root included, and the root's
 * context has no `authGateState` yet. Reading `.status` off it crashed the app
 * into its error screen (Sentry AMOREG-EVE-C). Components rendered in that
 * window read the gate here and treat `undefined` as "still loading".
 */
export function useAuthGateState() {
  const authGateState = useRouteContext({
    from: rootRouteId,
    select: (context) => context.authGateState,
  });
  return authGateState as typeof authGateState | undefined;
}
